export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_expenseName') || '费用项目',
    field: 'expenseName',
    align: 'center',
    width: 200,
    slots: { edit: 'expense' },
    editRender: { enabled: true },
  },
  {
    title: that.$l('table_label_financeExpense') || '财务费用',
    field: 'v_expenseType',
    align: 'center',
    width: 200,
  },
  {
    title: that.$l('table_label_currencyAmount') || '计费金额',
    field: 'v_currencyAmount',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_customer') || '客户',
    field: 'custName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_customsNo') || '报关发票号',
    field: 'customsNo',
    width: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_expenseRemark') || '费用说明',
    field: 'expenseRemark',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    editRender: {
      name: 'ElInput',
      props: {
        placeholder: '请输入费用说明',
        maxlength: 500,
        'show-word-limit': true
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
